/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import { useTranslator } from '@jutro/locale';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AgencyAdminService } from 'twia-capability-agencyadmin';
import metadata from './AddNewUser.metadata.json5';
import styles from './AddNewUser.module.scss';
import { useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import _, { isUndefined, isEmpty, isArray } from 'lodash';
import { useValidation } from '@xengage/gw-portals-validation-react';
import messages from './AddNewUser.messages';

import { Button, CheckboxField } from '@jutro/legacy/components';

function AddNewUser(props) {
  const { addAgency, countUser, userRoles, orgsUser, history, isParentValid, getAddAgencyContentValue
    , addNewUserVisible, id, associationName_TWIA, updateVM, parentFieldValidation } = props
  const viewModelService = useContext(ViewModelServiceContext);
  const { refreshData } = useDataRefresh();
  const [visibility, setVisibility] = useState(false);
  const [addNewUser, updateAddNewUserVM] = useState();
  const [buttonVisible, setButtonVisibile] = useState(false);
  const [roleVisible, setRoleVisibile] = useState(false);
  const [selectUserVisible, setSelectUserVisibile] = useState(false);
  const { authHeader } = useAuthentication();
  const { showConfirm, showAlert } = useModal();
  const { onValidate, isComponentValid, registerComponentValidation } = useValidation('AddNewUser');
  const [rowSelectedId, setRowSelectedId] = useState();
  const [usersRoles, setUsersRoles] = useState(userRoles);
  const [showErrors, setShowErrors] = useState(false);
  const translator = useTranslator();
  const isPhoneNumberValid = (phone) => /^[2-9]\(?([0-9]{2})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(phone);
  const [phoneValidationMessage, setPhoneValidationMessage] = useState([]);
  const ACTION_MSG = {
    cancelAction: {
      title: translator(messages.agencyCancelTitle),
      message: translator(messages.cancelMessage),
      status: 'info',
      icon: 'mi-error-outline',
      confirmButtonText: translator(messages.confirmButtonText),
      cancelButtonText: translator(messages.cancelButtonText)
    }
  };

  const createUserDtoVM = () => {
    let path = '';

    //DE15365 added check for userDTO creation based on association Name
    if (associationName_TWIA === 'twia') {
      path = 'org.twia.elevate.edge.capabilities.agent.dto.UserDTO'

    } else {
      path = 'org.tfpa.edge.capabilities.agent.dto.UserDTO'
    }

    const addNewUserVM = viewModelService.create(
      {},
      'pc',
      path
    );

    updateAddNewUserVM(addNewUserVM)

    return addNewUserVM
  }

  useEffect(() => {

    createUserDtoVM();

  }, []);

  useEffect(() => {
    //Done code fixes.
    let path = '';

    if (associationName_TWIA === 'twia') {
      path = 'org.twia.elevate.edge.capabilities.agent.dto.UserDTO'

    } else {
      path = 'org.tfpa.edge.capabilities.agent.dto.UserDTO'
    }

    const addNewUserVM = viewModelService.create(
      {},
      'pc',
      path
    );

    setRoleVisibile(false);
    setButtonVisibile(false);
    updateAddNewUserVM(addNewUserVM);
  }, [countUser])

  const selectedExistingUser = (index) => {

    if (_.get(addAgency, 'primaryPersonContact.emailAddress1.value') && orgsUser.length >= 1) {

      const addNewUserVM = createUserDtoVM();

      _.set(addNewUserVM, 'value', orgsUser[index]);

      updateAddNewUserVM(addNewUserVM)
    }

  }


  useEffect(() => {

    if (!isUndefined(countUser)) {
      if (countUser == 0) {
        setVisibility(true);
        setSelectUserVisibile(false);
        setRoleVisibile(true);
        setButtonVisibile(true);

        _.set(addNewUser, 'email', _.get(addAgency, 'primaryPersonContact.emailAddress1.value'))
        addNewUser.value.userRoles = userRoles

      }
      else {
        setSelectUserVisibile(true);
        setVisibility(false);
        setRoleVisibile(false);
        setButtonVisibile(false);
        setUsersRoles([]);
      }


    }

  }, [countUser, addAgency, userRoles])

  useCallback(() => {
    if (onValidate) {
      onValidate(isComponentValid, id);
    }
  }, [id, isComponentValid, onValidate]);

  const updateAgencyVM = useCallback((addNewUser) => {
    if (!isArray(addNewUser)) {
      const contactName = `${_.get(addNewUser, 'firstName.value')}, ${_.get(addNewUser, 'lastName.value')}`;

      _.set(addAgency, 'primaryPersonContact.firstName.value', _.get(addNewUser, 'firstName.value'))
      _.set(addAgency, 'primaryPersonContact.lastName.value', _.get(addNewUser, 'lastName.value'))
      _.set(addAgency, 'primaryPersonContact.emailAddress1.value', _.get(addNewUser, 'email.value'))
      _.set(addAgency, 'primaryPersonContact.contactName.value', contactName)
      _.set(addAgency, 'primaryPersonContact.workNumber.value', _.get(addNewUser, 'phoneNumber.value'))
      _.set(addAgency, 'reasonDescription_Ext.value', " ");
      updateVM(addAgency);
    }
  })

  const onCancel = useCallback(() => {
    // history.push('/administration');
    const message = ACTION_MSG.cancelAction;

    showConfirm(message).then(results => {
      if (results === 'confirm') {
        getAddAgencyContentValue(false);
      }
    })
  })

  const submitNewUser = useCallback(() => {

    if (!isComponentValid || !isParentValid) {
      setShowErrors(true)
      parentFieldValidation();

      return false
    }

    // DE17802
    if (_.every(addNewUser?.userRoles.value, (role) => !role.isApplicable)) {
      showAlert({
        title: translator(messages.RoleValidationTitle),
        message: translator(messages.RoleValidationMessage),
        status: 'error',
        icon: 'mi-error-outline',
        confirmButtonText: translator(messages.RoleButtonCloseMessage),
      })

      return false;
    }

    if (countUser == 0) {
      if (associationName_TWIA === 'twia') {
        // DE15437
        AgencyAdminService.addNewProducerGroup(addAgency.value, addNewUser.value, authHeader).then((res) => {
          history.go('/administration');
        })
      }
      else {
        AgencyAdminService.addNewProducerGroup_tfpa(addAgency.value, addNewUser.value, authHeader).then((res) => {
          history.go('/administration');
        })
      }

    }
    else {
      const contactName = orgsUser[rowSelectedId].firstName + ', ' + orgsUser[rowSelectedId].lastName;

      _.set(addAgency, 'primaryPersonContact.firstName.value', orgsUser[rowSelectedId].firstName)
      _.set(addAgency, 'primaryPersonContact.lastName.value', orgsUser[rowSelectedId].lastName)
      _.set(addAgency, 'primaryPersonContact.contactName.value', contactName)
      _.set(addAgency, 'primaryPersonContact.workNumber.value', orgsUser[rowSelectedId].phoneNumber)
      _.set(addAgency, 'reasonDescription_Ext.value', " ")

      // DE15437
      if (associationName_TWIA === 'twia') {
        AgencyAdminService.addNewProducerGroup(addAgency.value, orgsUser[rowSelectedId], authHeader).then((res) => {
          history.go('/administration');
        })
      } else {
        AgencyAdminService.addNewProducerGroup_tfpa(addAgency.value, orgsUser[rowSelectedId], authHeader).then((res) => {
          history.go('/administration');
        })
      }

    }
    // getAddAgencyContentValue(false);

  }, [addAgency, addNewUser, authHeader, countUser, isComponentValid, isParentValid])

  const getCell = useCallback(
    (item, index, property) => {

      if (property.id === "isEFTEnabled") {
        return (
          <span >
            {item[property.id] ? "Yes" : "No"}
          </span>
        );
      }

      if (property.id === "status") {
        return (
          <span >
            {item[property.id] ? "Active" : "Inactive"}
          </span>
        );
      }

      return (
        <span >
          {item[property.id]}
        </span>
      );
    },
    [translator]
  );


  const handleClick = useCallback(
    (value, path, index) => {
      const indexNew = _.findIndex(addNewUser.userRoles.value, { name: path.name })

      _.set(addNewUser.userRoles.value[indexNew], 'isApplicable', value);
      updateAddNewUserVM(addNewUser);
      refreshData();
    },
    [addNewUser, refreshData]
  );

  const getCheckBox = useCallback(
    (item, index) => (
      <CheckboxField
        value={item.isApplicable}
        onValueChange={e => handleClick(e, item, index)}
      />
    ),
    [handleClick]
  );

  const setUserSelectedData = (index) => {
    setButtonVisibile(true);
    setRoleVisibile(true);
    setUsersRoles(orgsUser[index]?.userRoles);
    selectedExistingUser(index);
    setRowSelectedId(index);
  }

  const getUserSelected = useCallback((item, index, property) => (
    <Button
      onClick={() => { setUserSelectedData(index) }}
    >
      Select
    </Button>
  ));

  const validatePhoneNumber = useCallback(
    (value) => {

      if (value.length === 3 || value.length === 7) {
        value += "-"
      }

      setPhoneValidationMessage([]);

      if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {

        setPhoneValidationMessage([translator(messages.PhoneValidationMessage)])
      }

    },
    [translator]);

  const writeValue = useCallback(
    (value, path) => {
      _.set(addNewUser, path, value);
      updateAddNewUserVM(addNewUser);
      updateAgencyVM(addNewUser);

      if (path === 'email') {
        setVisibility(false);
        setButtonVisibile(false);
        setRoleVisibile(false);
      }

      if (path === 'phoneNumber' && !_.isEmpty(addNewUser.phoneNumber.value)) {
        validatePhoneNumber(value)
      }
      else {
        setPhoneValidationMessage([translator(messages.PhoneValidationRequiredMessage)])
      }

      refreshData();
    },
    [addNewUser, refreshData, updateAgencyVM]
  );

  const overrideProps = {
    // DE15410
    '@field': {
      labelPosition: 'left',
      showErrors,
      phoneWide: {
        labelPosition: 'top',
      },
    },
    selectUserHeader: {
      visible: selectUserVisible && addNewUserVisible
    },
    tableExistingUserDetails: {
      visible: selectUserVisible && addNewUserVisible,
      data: orgsUser
    },
    buttoncontainer: {
      visible: buttonVisible && addNewUserVisible
    },
    userGridlayout: {
      visible: visibility && addNewUserVisible
    },
    newUserHeader: {
      visible: visibility && addNewUserVisible
    },
    rolesHeader: {
      visible: roleVisible && addNewUserVisible
    },
    tableUserRolesDetail: {
      visible: roleVisible && addNewUserVisible,
      data: countUser > 0 ? usersRoles.filter(role => role.isApplicable) : userRoles, // Done fixes for Existing user to show only applicable roles

    },
    // DE15347 
    tableGetCheckbox: {
      visible: isUndefined(orgsUser), // Reverted changes for checkboxes of Existing user
    },
    eftEnabled: {
      visible: associationName_TWIA !== 'tfpa'
    },
    newUserNumber: {
      // validationMessages: addNewUser?.phoneNumber?.aspects.valid ? [] : phoneValidationMessage
    }
  };

  const resolvers = {
    resolveClassNameMap: styles,
    resolveCallbackMap: {
      onCancel,
      submitNewUser,
      getCell,
      updateAgencyVM,
      getUserSelected,
      getCheckBox
    },
  };

  return (
    <ViewModelForm
      uiProps={metadata.pageContent}
      model={addNewUser}
      onValueChange={writeValue}
      overrideProps={overrideProps}
      // componentMap={resolvers.resolveComponentMap}
      classNameMap={resolvers.resolveClassNameMap}
      callbackMap={resolvers.resolveCallbackMap}
      onValidationChange={onValidate}
    />
  );
}

AddNewUser.propTypes = {
  userRoles: PropTypes.arrayOf(PropTypes.object),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  authHeader: PropTypes.shape({}).isRequired
};

AddNewUser.defaultProps = {

};

export default withAuthenticationContext(withRouter(AddNewUser));
